import { createContext, useContext, useMemo } from 'react';

const CurrentPressroomContext = createContext<{
  pressroomId: string;
  sourceId: string;
  trial: boolean;
}>({
  pressroomId: '',
  sourceId: '',
  trial: false,
});

export const CurrentPressroomContextProvider = ({
  sourceId,
  pressroomId,
  trial,
  children,
}: {
  sourceId: string | undefined;
  pressroomId: string | undefined;
  trial: boolean | undefined;
  children: React.ReactNode;
}) => {
  return (
    <CurrentPressroomContext.Provider
      value={useMemo(() => {
        return {
          sourceId: sourceId || '',
          pressroomId: pressroomId || '',
          trial: !!trial,
        };
      }, [sourceId, pressroomId, trial])}
    >
      {children}
    </CurrentPressroomContext.Provider>
  );
};

export const useCurrentPressroom = () => useContext(CurrentPressroomContext);
